app.directive('domainsAdminTree', [
    '$rootScope', '$timeout', '$window', 'DomainsApiService', 'utilsService', 'semanticUIService', 'storageService',
    function ($rootScope, $timeout, $window, DomainsApiService, utilsService, semanticUIService, storageService) {
        return {
            restrict: "E",
            templateUrl: "/templates/partials/directives/domains/domains-admin-tree.html",
            scope: {
                collection: '=',
                onDelete: '='
            },
            link: function (scope) {
                scope.tree = null;
                scope.selectedDomain = null;
                scope.deleteLoading = null;
                scope.getUri = DomainsApiService.getUri;
                scope.ordonateMap = {};
                $rootScope.openedPanels = storageService.has('domains.opened')
                    ? storageService.get('domains.opened').split(',').map(function (i) {
                        return parseInt(i, 10);
                    })
                    : [];

                scope.$watch('collection', function (collection) {
                    scope.tree = scope.toArray(collection);
                    scope.selectedDomain = null;

                    $timeout(function () {
                        var accordion = semanticUIService.load('accordion', undefined, {
                            onOpen: function () {
                                if (parseInt(this.dataset.depth, 10) === 0) {
                                    $rootScope.openedPanels = [];
                                    accordion.accordion('refresh');
                                }
                                var id = parseInt(this.dataset.id, 10);
                                if ($rootScope.openedPanels.indexOf(id) < 0) {
                                    $rootScope.openedPanels.push(id);
                                }
                                storageService.set('domains.opened', $rootScope.openedPanels.join(','));
                            },
                            onClose: function () {
                                if (parseInt(this.dataset.depth, 10) === 0) {
                                    $rootScope.openedPanels = [];
                                    accordion.accordion('refresh');
                                } else {
                                    var self = this;
                                    $rootScope.openedPanels = $rootScope.openedPanels.filter(function (value) {
                                        return value !== self.dataset.id;
                                    });
                                }
                                storageService.set('domains.opened', $rootScope.openedPanels.join(','));
                            }
                        });

                        if ($rootScope.openedPanels.length && scope.tree.length) {
                            $timeout(function () {
                                $window.location.hash = "#node-" + utilsService.first($rootScope.openedPanels);
                                storageService.remove('domains.opened');
                            });
                        }
                    });
                });

                scope.isActive = function (node) {
                    return $rootScope.openedPanels.indexOf(parseInt(node.id, 10)) >= 0;
                };

                scope.getStoreUri = function (node) {
                    return DomainsApiService.getUri('/store?parent_id=' + node.id);
                };

                scope.getEditUri = function (node) {
                    var uri = DomainsApiService.getUri('/:id/edit', {id: node.id});

                    if (node.parent_id) {
                        uri += '?parent_id=' + node.parent_id;
                    }

                    return uri;
                };

                scope.moveUp = function (node) {
                    var pos = angular.copy(node).position;

                    if (pos === scope.tree.length) {
                        return false;
                    }

                    scope.tree.forEach(function (n) {
                        if (n.position === pos + 1) {
                            n.position = scope.ordonateMap[n.id] = pos;
                        }
                    });

                    node.position = scope.ordonateMap[node.id] = pos + 1;

                    scope._onMove();
                };

                scope.size = function (obj) {
                    let size = 0, key;
                    for (key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            size++;
                        }
                    }

                    return size;
                };

                scope.toArray = function (obj) {
                    if (angular.isUndefined(obj)) {
                        return [];
                    }

                    return Object.values(obj);
                };

                scope.moveDown = function (node) {
                    var pos = angular.copy(node).position;

                    if (pos === 1) {
                        return false;
                    }

                    scope.tree.forEach(function (n) {
                        if (n.position === pos - 1) {
                            n.position = scope.ordonateMap[n.id] = pos;
                        }
                    });

                    node.position = scope.ordonateMap[node.id] = pos - 1;

                    scope._onMove();
                };

                scope._onMove = function () {
                    scope.orderLoading = true;
                    DomainsApiService.ordonate(scope.ordonateMap)
                        .then(function () {
                            scope.ordonateMap = {};
                            scope.orderLoading = false;
                        });
                };

                scope.onDomainDelete = function (e, node) {
                    e.preventDefault()

                    if (!confirm("Confirmer la suppression de '" + node.name + "' (les sous-domaines seront déplacés au domaine parent) ?")) {
                        e.preventDefault();
                        return false;
                    }

                    scope.deleteLoading = node.id;
                    DomainsApiService
                        .destroy(node.id)
                        .catch(err => $rootScope.$broadcast('admin.domains.delete.error', err.data))
                        .then(_ => scope.onDelete())
                        .finally(() => scope.deleteLoading = null);
                };
            }
        }
    }]);